import React, { useState, useEffect } from "react"
import service from "../service/axios"

import Container from "../components/Container"
import Achievement from "../components/Achievement"
import Loader from "../components/Loader"

export default function Testimonials() {
  const [testimonials, setTestimonials] = useState([])

  const getTestimonials = async () => {
    const data = await service.getData("testimonials")
    setTestimonials(data)
  }

  useEffect(() => {
    getTestimonials()
  }, [])

  return (
    <Container>
      <article id="testimonials" className="wrapper">
        <h1>Testimonials</h1>

        {
          testimonials.length === 0
            ? <Loader />
            : <div className="edu-container">
              {
                testimonials?.map((a, i) => (
                  <Achievement
                    key={i}
                    title={a?.title}
                    link={a?.link}
                    header={a?.header}
                    content={a?.content}
                    author={a?.author}
                  />
                ))
              }
            </div>
        }
      </article>
    </Container>
  )
}
